var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.82 9.5 5.907-5.852c.328-.328.328-.93 0-1.257l-1.368-1.368c-.328-.328-.93-.328-1.257 0L9.25 6.93 3.344 1.023c-.328-.328-.93-.328-1.258 0L.719 2.391c-.328.328-.328.93 0 1.257L6.625 9.5.719 15.406c-.328.328-.328.93 0 1.258l1.367 1.367c.328.328.93.328 1.258 0l5.906-5.906 5.852 5.906c.328.328.93.328 1.257 0l1.368-1.367c.328-.328.328-.93 0-1.258L11.82 9.5Z",
    fill: "#ED1651"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross2);
export default __webpack_public_path__ + "static/media/cross2.1e1f132e0f89d5f126fe54b887cd6800.svg";
export { ForwardRef as ReactComponent };